module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "static/img/logo.png",
      "alt": "User Image"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.png",
      "alt": "User Image"
    }
  }), _c('b', [_vm._v("Devin")]), _vm._v("vue")])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": 20,
      "max": 9
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-email"
  })])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have 10+ Message")]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Announcements "), _c('span', [_vm._v("Just Now !")])]), _vm._v(" "), _c('p', [_vm._v("Pok ame ame belalang kupu kupu")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Complete your profile"), _c('span', [_vm._v("2 Min Ago")])]), _vm._v(" "), _c('p', [_vm._v("Siang makan nasi kalo malam minum susu")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("New Schedule Realease"), _c('span', [_vm._v("30 Min ago")])]), _vm._v(" "), _c('p', [_vm._v("Bintang kecil dilangit yang tinggi")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("New Student Data"), _c('span', [_vm._v("1 Hour ago")])]), _vm._v(" "), _c('p', [_vm._v("Amat banyak menghias angkasa")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Graduate Student List"), _c('span', [_vm._v("2 Days ago")])]), _vm._v(" "), _c('p', [_vm._v("Aku ingin terbang dan melayang, jauh tinggi ke tempat kau berada")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all")])])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item ",
    attrs: {
      "is-dot": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-bell"
  })])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have 10 notifications")]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('i', {
    staticClass: "ti-announcement"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Announcements "), _c('span', {
    staticClass: "text-green fontello-record"
  })]), _vm._v(" "), _c('p', [_vm._v("Just Now !")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Complete your profile"), _c('span', {
    staticClass: "text-yellow fontello-record"
  })]), _vm._v(" "), _c('p', [_vm._v("2 Min Ago")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-notepad"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("New Schedule Realease"), _c('span', {
    staticClass: "text-yellow fontello-record"
  })]), _vm._v(" "), _c('p', [_vm._v("30 Min ago")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-agenda"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("New User Data"), _c('span', {
    staticClass: "text-orange fontello-record"
  })]), _vm._v(" "), _c('p', [_vm._v("1 Hour ago")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-package"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("New User List"), _c('span', {
    staticClass: "fontello-record"
  })]), _vm._v(" "), _c('p', [_vm._v("2 Days ago")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all")])])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-button', {
    attrs: {
      "data-toggle": "control-sidebar",
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "dripicons-swap"
  })])], 1)])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left-search"
  }, [_c('form', {
    attrs: {
      "id": "demo-2"
    }
  }, [_c('input', {
    staticClass: "devin-search",
    attrs: {
      "type": "search"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b185a408!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 1027
// module chunks = 2